import {
    RichText, RichTextBlock
} from 'prismic-reactjs';

import SunnysideGrid from '../../../components_sunnyside/grid';
import termsPolicySerializer from '../../../utils/prismic/serializers/termsPolicySerializer';
import {
    PrismicBasicPageResponseData
} from '../../../utils/prismic/types/pages/basic.type';
import {
    PrismicBodyText
} from '../../../utils/prismic/types/prismic-slice.type';

interface TermsPolicyProps {
    termsPolicy: PrismicBasicPageResponseData
}

export default function TermsPolicy(props: TermsPolicyProps): JSX.Element {
    const {
        termsPolicy
    } = props;

    const sliceObject = termsPolicy.data.body[0].primary as PrismicBodyText;
    const richTextBlock = sliceObject.body_text as RichTextBlock[];

    const anchorElementIndex = richTextBlock?.findIndex(y => y.text.includes('FEES, RENEWAL, CANCELLATIONS & REFUND POLICIES'));
    if (richTextBlock[anchorElementIndex]) {
        (richTextBlock[anchorElementIndex] as RichTextBlock & { id: string }).id = 'subscription';
    }

    return (
        <SunnysideGrid
            maxwidthgrid
            display='flex'
            flexDirection='column'
        >
            <RichText
                render={richTextBlock}
                htmlSerializer={termsPolicySerializer}
            />
        </SunnysideGrid>
    );
}
